// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__UV-sS","disabled":"styles_disabled__GpybT","outlined":"styles_outlined__m0Rjr","blue":"styles_blue__uZgcT"};